import { observable, runInAction } from 'mobx'
import { CmsLink, LocationAnnouncementApi } from '../'

class LocationService {
    locationName = observable.box(null as string)
    locationLinks = observable.box(null as CmsLink[])
    locationAnnouncement = observable.box(null as LocationAnnouncementApi)

    setlocationName(newName: string) {
        runInAction(() => {
            this.locationName.set(newName)
        })

        return true
    }

    getLocationName = () => this.locationName.get()

    setlocationLinks(newLinks: CmsLink[]) {
        runInAction(() => {
            this.locationLinks.set(newLinks)
        })

        return true
    }

    getLocationLinks = () => this.locationLinks.get()

    setLocationAnnouncement(newAnnouncement: LocationAnnouncementApi) {
        runInAction(() => {
            this.locationAnnouncement.set(newAnnouncement)
        })

        return true
    }

    getLocationAnnouncement = () => this.locationAnnouncement.get()
}

export const locationService = new LocationService()
